import { type OptionsType, getCookie, setCookie } from 'cookies-next/server'
// Subpath imports: the crypto-js barrel ships every cipher (~20 KB gz) to the
// client; MD5 + hex encoding is all we use.
import encHex from 'crypto-js/enc-hex'
import md5 from 'crypto-js/md5'
import { ServerResponse } from 'http'
import { NextRequest, NextResponse } from 'next/server'
import { v4 } from 'uuid'
import {
  DUPE_AUTH_USER_ID_KEY,
  DUPE_SESSION_COOKIE_KEY,
  MAX_AGE_OF_COOKIE,
  TEMP_USER_ID_KEY,
} from '~/src/lib/constants'

export const stringToHash = (str: string) => {
  return md5(str).toString(encHex)
}

export const isValidImageUrl = (url: string) => {
  try {
    if (url.startsWith('https://https')) {
      return false
    }

    new URL(url)
    return true
  } catch (_e) {
    return false
  }
}

// decodeSourceFromHash lives in ~/src/lib/lookupUrlFromHash — it needs the db,
// and this module must stay db-free (it is imported by client-bundled code,
// e.g. AuthProvider's stringToHash).

export const getTempUserIdCookieFromRequest = async (req: NextRequest) => {
  return await getCookie(TEMP_USER_ID_KEY, { req })
}

export const getUserIdCookieFromRequest = async (req: NextRequest) => {
  return await getCookie(DUPE_AUTH_USER_ID_KEY, { req })
}

export const generateAndSetTempUserIdServer = ({
  res,
}: {
  res: ServerResponse
}) => {
  const uuid = v4()

  const cookieOptions: OptionsType = {
    expires: new Date(Date.now() + 1000 * MAX_AGE_OF_COOKIE),
    maxAge: MAX_AGE_OF_COOKIE,
    path: '/',
    res,
  }

  if (process.env.NEXT_PUBLIC_VERCEL_ENV === 'production') {
    cookieOptions.domain = '.dupe.com'
  }

  setCookie(TEMP_USER_ID_KEY, uuid, cookieOptions)

  return uuid
}

export const generateAndSetTempUserIdMiddleware = ({
  res,
}: {
  res: NextResponse
}) => {
  const uuid = v4()

  const cookieOptions: OptionsType = {
    expires: new Date(Date.now() + 1000 * MAX_AGE_OF_COOKIE),
    maxAge: MAX_AGE_OF_COOKIE,
    path: '/',
  }

  if (process.env.NEXT_PUBLIC_VERCEL_ENV === 'production') {
    cookieOptions.domain = '.dupe.com'
  }

  res.cookies.set(TEMP_USER_ID_KEY, uuid, cookieOptions)

  return uuid
}

export const getDupeSessionCookie = (req: NextRequest) => {
  return getCookie(DUPE_SESSION_COOKIE_KEY, { req })
}
